import { ActionStatusService } from 'common/components/contextMenu/interfaces';
import { qtiTypes } from 'common/store/common/constants';
import { isNullOrUndefined } from 'common/util/type/typeUtil';
import store from '../store';
import { RootState } from '../store/rootReducer';
import { Actions as permissionActions, permissionService } from './permissions/PermissionService';
import { isQuestionAnswerKeyEnabled } from '../features/workflowSettings/services/workflowSettingsService';

interface Actions {
    [key: string]: (state: any) => any;
}

const actionNames: Actions = {
    ToggleLock: (state: any) => { return state.editMode || false; },
    useDecimal: (state: any) => { return state.decimal || false; },
    flag: (state: any) => { return state.score && state.score.flagged; },
    toggleHeader: (state: any) => { return state.showHeader; },
    toggleHtmlEditor: (state: any) => { return state.htmlEditorMode; },
    showAnnotations: (state: any) => { return state.annotationSidebarVisible; },
    showQuestionTextInSubmission: (state: any) => { return state.showQuestionTextInSubmission; },
    expand: (state: any) => { return state.isExpanded; },
    toggleSourceMode: (state: any) => { return state.sourceMode; },
};

const actionDisabledNames: Actions = {
    downloadSubmissionFile: (state: any) => {
        const { assessment } = store.getState() as RootState;

        return !(assessment?.isUploadedFilesPdfConversion
            && state.candidateResponseId);
    },
    downloadSubmissionFilePdf: (state: any) => {
        const { assessment } = store.getState() as RootState;
        return !(assessment?.isUploadedFilesPdfConversion
            && state.convertedCandidateResponseId);
    },
    sendExplanationToAllCandidates: (state: RootState) => {
        const { assessment } = state;
        return !(assessment?.enableBulkReleaseOfExplanations
        && assessment.numberOfCandidatesWithExplanationNotSent > 0);
    },
};

const actionEnabledNames: Actions = {
    sendExplanationToAllCandidates: (state: RootState) => {
        const { assessment } = state;
        return (assessment?.enableBulkReleaseOfExplanations);
    },
};

const actionStatusService: ActionStatusService = {
    isActionActive(state: any, actionName: string, featureId?: string): boolean {
        const aGenericPromotedAction = !!featureId;
        if (aGenericPromotedAction) {
            const genericFeatureState = (store.getState() as RootState).workspaces.genericFeatureState[featureId];
            return actionNames[actionName](genericFeatureState) || false;
        }
        if (!actionNames[actionName] || !state) {
            return false;
        }
        return actionNames[actionName](state) || false;
    },

    isActionInProgress(): boolean {
        return false;
    },

    isActionDisabled(state: any, actionName: string): boolean {
        if (!actionDisabledNames[actionName] || !state) {
            return false;
        }
        return actionDisabledNames[actionName](state) || false;
    },

    hasPermissionForAction(action: string, featureState: any): boolean {
        const rootState = store.getState() as RootState;
        const { context: { partyState } } = rootState;

        if (action === permissionActions.EDIT_ANSWER_KEYS
            && featureState?.question?.type === qtiTypes.MULTIPLE_CHOICE
            && isQuestionAnswerKeyEnabled()) {
            return true;
        }

        if (action === permissionActions.DOWNLOAD_SUBMISSION_FILE
            && !isNullOrUndefined(featureState?.candidateResponseId
            && !isNullOrUndefined(featureState?.convertedCandidateResponseId))) {
            return true;
        }

        if (action === permissionActions.SEND_EXPLANATION_TO_ALL_CANDIDATES) {
            return !actionDisabledNames.sendExplanationToAllCandidates(rootState);
        }

        if (partyState?.gradingPartyDocument && action) {
            return permissionService.hasPermissionForAction(action, partyState.gradingPartyDocument);
        }

        return false;
    },

    isActionVisible(action: string): boolean {
        const rootState = store.getState() as RootState;

        if (actionEnabledNames[action]) {
            return actionEnabledNames[action](rootState);
        }

        return true;
    },
};

export default actionStatusService;
